<mpro-modal class="categories-consumer" [(open)]="isModalOpen" (openChange)="closeModal()" [showCloseButton]="false">
    <main>
      <h4>Turning Categories Consumer Demand on</h4>
      <p>{{message}}</p>
      <div class="buttons">
        <button class="mpro-btn mpro-btn-secondary" (click)="closeModal()">NO</button>
        <button class="mpro-btn mpro-btn-primary" (click)="switchCategories()">YES</button>
      </div>
    </main>
</mpro-modal>
